import React from 'react'
import Particles from 'react-particles-js'
import './style.scss'
import { Fade } from 'components/GeneralComponents/Animations'

const ParticlesOverlay = ({ children, fullscreen = false, fadeIn }) => {
  return (
    <div className={`d-flex h-100 align-items-start ${fullscreen ? 'overlay' : ''}`}>
      <Particles
        className="bg-particle"
        params={{
          particles: {
            number: {
              value: 60,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: '#008ccf',
            },
            shape: {
              type: 'circle',
              stroke: {
                width: 0,
                color: '#000000',
              },
            },
            opacity: {
              value: 0.1,
              random: false,
              anim: {
                enable: false,
                speed: 1,
                opacity_min: 0.05,
                sync: false,
              },
            },
            size: {
              value: 5,
              random: true,
              anim: {
                enable: false,
                speed: 40,
                size_min: 0.1,
                sync: false,
              },
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: '#4fb0e8',
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 3,
              direction: 'none',
              random: false,
              straight: false,
              out_mode: 'out',
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          retina_detect: true,
        }}
      />
      <main className="container minimal-spacing align-self-center">
        <div className="row p-3 mb-5">
          <div className="col">
            <div className="text-center">
              <div className="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
                {fadeIn ? <Fade in>{children}</Fade> : children}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default ParticlesOverlay
